import React from "react";
import LegalLayout, { Section, InlineLink } from "@/pages/LegalLayout";

const Privacy = () => (
  <LegalLayout
    title="Ochrana osobních údajů"
    metaTitle="Ochrana osobních údajů | SANVIORO"
    description="Zásady zpracování osobních údajů SANVIORO — Sanvioro s.r.o. (IČO 29637066). Jaké údaje zpracováváme, za jakým účelem a jaká jsou vaše práva dle GDPR."
    path="/ochrana-osobnich-udaju"
  >
    <p className="text-[#333333]">
      SANVIORO dbá na ochranu osobních údajů a zpracovává je v souladu
      s platnými právními předpisy, zejména nařízením GDPR.
    </p>

    <Section title="Správce údajů">
      <ul className="space-y-1">
        <li><strong>Sanvioro s.r.o.</strong></li>
        <li>IČO: 29637066</li>
        <li>Sídlo: Příkop 843/4, Zábrdovice, 602 00 Brno, Česká republika</li>
        <li>
          E-mail:{" "}
          <InlineLink external to="mailto:info@sanvioro.cz">
            info@sanvioro.cz
          </InlineLink>
        </li>
        <li>
          Telefon:{" "}
          <InlineLink external to="tel:+420775601254">
            +420 775 601 254
          </InlineLink>
        </li>
      </ul>
    </Section>

    <Section title="Jaké údaje zpracováváme">
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>Jméno a příjmení</li>
        <li>Telefonní číslo</li>
        <li>E-mailová adresa</li>
        <li>Informace uvedené v poptávkovém formuláři</li>
        <li>Technické údaje o návštěvě webu (cookies, analytika)</li>
      </ul>
    </Section>

    <Section title="Za jakým účelem údaje zpracováváme">
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>Vyřízení poptávky</li>
        <li>Komunikace se zákazníkem</li>
        <li>Příprava cenové nabídky</li>
        <li>Plnění smluvních povinností</li>
        <li>Ochrana oprávněných zájmů správce</li>
        <li>Zlepšování webových stránek a služeb</li>
      </ul>
    </Section>

    <Section title="Doba uchování údajů">
      <p>
        Osobní údaje uchováváme pouze po dobu nezbytně nutnou pro splnění
        účelu zpracování nebo dle zákonných povinností.
      </p>
    </Section>

    <Section title="Předávání třetím stranám">
      <p>
        Údaje mohou být zpřístupněny pouze ověřeným dodavatelům služeb
        (hosting, účetnictví, IT podpora), a to v nezbytném rozsahu.
      </p>
    </Section>

    <Section title="Vaše práva">
      <p>Máte právo na:</p>
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>přístup k údajům</li>
        <li>opravu údajů</li>
        <li>výmaz údajů</li>
        <li>omezení zpracování</li>
        <li>přenositelnost údajů</li>
        <li>vznesení námitky</li>
        <li>podání stížnosti u ÚOOÚ</li>
      </ul>
    </Section>

    <Section title="Kontakt">
      <p>
        V případě dotazů nás kontaktujte na e-mailu{" "}
        <InlineLink external to="mailto:info@sanvioro.cz">
          info@sanvioro.cz
        </InlineLink>
        . Více informací o nás najdete na stránce{" "}
        <InlineLink to="/o-nas">O nás</InlineLink> nebo si přečtěte{" "}
        <InlineLink to="/obchodni-podminky">obchodní podmínky</InlineLink>.
      </p>
    </Section>
  </LegalLayout>
);

export default Privacy;
